import axios from "axios";

import { ElMessage } from "element-plus";

let pending = [];
const CancelToken = axios.CancelToken;
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + "&" + config.method + "&" + config.data) {
      pending[p].f();
      pending.splice(p, 1);
    }
  }
};
const http = axios.create({
  baseURL: "", //globalConfig.baseURL + 'api/',
  timeout: 180000, // 请求超时时间
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "X-Requested-With,Content-Type",
    "Access-Control-Allow-Methods": "POST,GET,OPTIONS",
  },
});

// request拦截器
http.interceptors.request.use(
  (config) => {
    removePending(config);
    config.cancelToken = new CancelToken((c) => {
      pending.push({ u: config.url + "&" + config.method, f: c });
    });

    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    } else {
      config.headers.token = "";
    }

    return config;
  }
);

http.interceptors.response.use(
  function (response) {
    removePending(response.config);
    if (response.status === 200) {
      if (response.data.code == 10) {
        ElMessage({
          message: response.data.msg,
          type: "error",
        });
        if (sessionStorage.getItem("token")) {
          sessionStorage.clear();
          location.reload()
        }
        return response.data;
      }
      if (response.data.code == null) return response;
      if (response.data.code === 0) {
        return response.data;
      }

      if (response.data.code == 1) {
        ElMessage({
          message: response.data.message,
          type: "error",
        });
        return response.data;
      } 
    }
  },
  function (error) {
    if (error && error != "Cancel") {
      ElMessage({
        ElMessage: error,
        type: "error",
      });
    }
  }
);

export default http;
